function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z",
  fill: "#4caf50"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z",
  fill: "#ffc107"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44 24c0 11.044-8.956 20-20 20S4 35.044 4 24 12.956 4 24 4s20 8.956 20 20z",
  fill: "#4caf50"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 4v20l8 4-8.843 16H24c11.053 0 20-8.947 20-20S35.053 4 24 4z",
  fill: "#ffc107"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M41.84 15H24v13l-3-1L7.16 13.26h-.02C10.68 7.69 16.91 4 24 4c7.8 0 14.55 4.48 17.84 11z",
  fill: "#f44336"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.158 13.264l8.843 14.862L21 27 7.158 13.264z",
  fill: "#dd2c00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.157 44l8.934-16.059L28 25l-4.843 19z",
  fill: "#558b2f"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M41.865 15H24l-1.579 4.58L41.865 15z",
  fill: "#f9a825"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33 24c0 4.969-4.031 9-9 9s-9-4.031-9-9 4.031-9 9-9 9 4.031 9 9z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M31 24c0 3.867-3.133 7-7 7s-7-3.133-7-7 3.133-7 7-7 7 3.133 7 7z",
  fill: "#2196f3"
});

function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    x: 0,
    y: 0,
    viewBox: "3 3 42 42",
    xmlSpace: "preserve",
    width: 60,
    height: 60
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgChrome;